//region :: Imports ::
import {ReactElement} from 'react';
import MComponent from '../Component';
import {MBoolean} from './Control';
import {MBackIconName} from '../../Icons';
import MButton from './Button';
import WithRouterProps from '../../WithRouterProps';
import withRouter from '../../WithRouter';

//endregion

/** */
type Props = WithRouterProps & {
    disabled: MBoolean;
}

/** */
class MBackButton extends MComponent<Props> {

    /** */
    public constructor(props: Props) {
        super(props);

    }

    /** */
    public render(): ReactElement {

        return (
            <MButton label="Back"
                     color="secondary"
                     iconOnly={true}
                     icon={MBackIconName}
                     tooltip="Go Back"
                     disabled={this.props.disabled}
                     onClick={() => this.props.history.goBack()}/>
        );

    }

}

export default withRouter(MBackButton);